<template>
  <div id="main">
    <NavBar id="navbar"/>
    <router-view></router-view>
    <Footer id="footer"/>
  </div>
</template>

<script>

import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default {
  name: "Index",
  components: {
    Footer,
    NavBar,
  },
  data() {
    return {
      navbar: null,
      footer: null,
      main: null,
    }
  },
  methods: {
    onViewChange() {
      let clientWidth = document.documentElement.scrollWidth - 2 + 'px';
/*      let clientWidth1 = document.documentElement.clientWidth;
      if (clientWidth1<500)
        clientWidth=clientWidth1*/
      this.navbar.style.width = clientWidth;
      this.main.style.width = clientWidth;
      this.footer.style.width = clientWidth;
    }
  },
  mounted() {
    this.navbar = document.getElementById("navbar");
    this.footer = document.getElementById("footer");
    this.main = document.getElementById("main");
    this.onViewChange();
    let that = this
    window.onscroll = function () {
      that.onViewChange();
    };
    window.onresize = function () {
      that.onViewChange();
    };
  }
}
</script>

<style scoped>
.el-main {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/Index.vue